import { FC } from 'react';
import { Location, Navigate, Outlet, useLocation } from 'react-router-dom';
import { User } from '../../utils/models';

import auth from '../../services/authService';

interface RoleBasedRouteProps {
	allowedRoles: string[];
	redirectPath: string;
}

const RoleBasedRoute: FC<RoleBasedRouteProps> = (props): JSX.Element => {
	const { allowedRoles, redirectPath } = props;

	const user = auth.getCurrentUser() as User;
	const location: Location = useLocation();

	const isPermitted: boolean = allowedRoles.some((r) => (user.role as any)[r]);
	if (isPermitted) return <Outlet />;

	return <Navigate to={redirectPath} state={{ from: location.pathname }} />;
};

export default RoleBasedRoute;
